import React from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Modal,
  Dimensions,
} from "react-native";
import { FontFamilies } from "@/constants/Typography";
import { Ionicons } from "@expo/vector-icons";
import { ActionButton } from "@/components/ActionButton";
import { BankOfferItem } from "@/types/feed";
import { TRACKING_EVENTS } from "@/constants/trackingEvents";
import FBTrackingService from "@/services/fbTrackingService";
import Icons from "@/assets/icons";
import { Image } from "expo-image";
import { BASE_URL } from "@/constants/Configs";
import { safeOpenURL } from "@/utils/linking";

interface BankOfferPopupProps {
  visible: boolean;
  onClose: () => void;
  data?: BankOfferItem;
}

const { width } = Dimensions.get("window");

const BankOfferPopup: React.FC<BankOfferPopupProps> = ({
  visible,
  onClose,
  data,
}) => {
  const handleLearnMore = async () => {
    const url = data?.signUpUrl;
    if (!url || url.trim() === '') {
      return;
    }
    FBTrackingService.trackEvent(
      TRACKING_EVENTS.BANK_OFFER_EXTERNAL_LINK_CLICKED,
      {
        eventData: {
          id: data?.id,
          title: data?.title,
          signUpUrl: url,
        },
      }
    );
    await safeOpenURL(url);
  };
  console.log(data);
  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={styles.overlay}>
        <View style={styles.modal}>
          {/* Close Button */}
          <TouchableOpacity style={styles.closeButton} onPress={onClose}>
            <Ionicons name="close" size={24} color="#666" />
          </TouchableOpacity>

          {data?.image && (
              <Image
                source={{ uri: BASE_URL + data?.image }}
                style={styles.image}
                resizeMode="contain"
              />
            )}

          {/* Main Title */}
          <Text style={styles.title}>
            Claim your {data?.signUpBonus} from {data?.title}
          </Text>

          {/* Description */}
          <Text style={styles.description}>
            Earn a {data?.signUpBonus} signup bonus when you deposit{" "}
            {data?.minDeposit} into the account within 60 days of opening.
          </Text>

          {/* Action Buttons */}
          <View style={styles.buttonContainer}>
            <ActionButton
              title="Learn more"
              icon={<Icons.OpenLink />}
              iconPosition="right"
              onPress={handleLearnMore}
            />

            <ActionButton title="Cancel" onPress={onClose} type="hide" />
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    width: 100,
    height: 100,
    borderRadius: 16,
    marginBottom: 24,
  },
  modal: {
    backgroundColor: "white",
    borderRadius: 16,
    padding: 24,
    width: width - 40,
    maxWidth: 400,
    alignItems: "center",
    paddingTop: 40,
  },
  closeButton: {
    position: "absolute",
    top: 16,
    right: 16,
    zIndex: 1,
  },
  title: {
    fontSize: 20,
    fontFamily: FontFamilies.InterTight.Bold,
    color: "#111",
    textAlign: "center",
    marginBottom: 12,
    lineHeight: 28,
  },
  description: {
    fontSize: 14,
    fontFamily: FontFamilies.Inter.Regular,
    color: "#666",
    textAlign: "center",
    marginBottom: 24,
    lineHeight: 20,
  },
  buttonContainer: {
    width: "100%",
    gap: 12,
  },
});

export default BankOfferPopup;
